import {
  useGetPipeSeriesSuspense,
  useGetUsersPreferencesPipeSeriesSuspense,
} from "@imi/api-client/index.js";
import { buildCustomPipeSeries } from "@src/core/api/customPipeSeries";
import { buildPipeSeriesPreference } from "@src/core/api/pipeSeriesPreference";
import { useCombinedQueryState } from "@src/core/api/queries/useCombinedQueryState";
import { useCustomPipeSeries } from "@src/core/api/useCustomPipeSeries";
import { usePipeSeriesPreference } from "@src/core/api/usePipeSeriesPreference";
import { useMemo } from "react";

export function usePipeSeriesData() {
  const pipeSeriesQuery = useCombinedQueryState({
    customSeries: useCustomPipeSeries(),
    pipeSeriesPreference: usePipeSeriesPreference(),
  });

  return useMemo(() => {
    if (pipeSeriesQuery.status !== "success") return pipeSeriesQuery;
    const { customSeries, pipeSeriesPreference } = pipeSeriesQuery.data;
    return {
      data: {
        customPipeSeries: buildCustomPipeSeries(customSeries),
        pipeSeriesPreference: buildPipeSeriesPreference(pipeSeriesPreference),
      },
      status: "success" as const,
    };
  }, [pipeSeriesQuery]);
}

export function usePipeSeriesDataSuspense() {
  const customSeries = useGetPipeSeriesSuspense();
  const pipeSeriesPreference = useGetUsersPreferencesPipeSeriesSuspense();

  return {
    customPipeSeries: useMemo(
      () => buildCustomPipeSeries(customSeries.data),
      [customSeries.data],
    ),
    pipeSeriesPreference: useMemo(
      () => buildPipeSeriesPreference(pipeSeriesPreference.data),
      [pipeSeriesPreference.data],
    ),
  };
}
